<template>
  <button type="button" class="btn btn-inline btn-link link-dark" @click="toggleRelativeDates">
    {{ dateTextRef }}
  </button>
</template>

<script lang="ts" setup>
import { ref, computed } from 'vue'
import { DateTimeUtil } from './LuxonUtil'
import { DateTime } from 'luxon'

const props = defineProps<{
  value?: DateTime
}>()

const showRelativeDateRef = ref(true)

const dateTextRef = computed(() => showRelativeDateRef.value 
  ? DateTimeUtil.toRelativeDate(props.value)
  : DateTimeUtil.toUserActionDate(props.value)
)

function toggleRelativeDates() {
  showRelativeDateRef.value = !showRelativeDateRef.value
}
</script>
